import { useTranslation } from "../hooks/useTranslation";

/**
 * Maps a stored English periodicity enum value ("Bi-Monthly", "Monthly", …) to its
 * translated label via the `contacts` i18n namespace.
 *
 * Display-ONLY, exactly like useContactEnumLabel/useCategoryName: the stored/emitted
 * value stays the canonical English string; this only affects what the user sees.
 * Unknown values fall through unchanged. null → "None".
 */
const VALUE_TO_KEY: Record<string, string> = {
  "Bi-Monthly": "bi_monthly",
  Monthly: "monthly",
  Quarterly: "quarterly",
  "Bi-Annually": "bi_annually",
  Annually: "annually",
  None: "none",
};

export const usePeriodicityLabel = () => {
  const { p } = useTranslation("contacts");
  return (value?: string | null): string => {
    const v = value ?? "None";
    return p(VALUE_TO_KEY[v] ?? "none", { defaultValue: v });
  };
};
